document.addEventListener('DOMContentLoaded', function () {
  // ===== 1. Detect language =====
  const supportedLangs = ['en', 'vn', 'id', 'th', 'cn'];
  const lang =
    supportedLangs.find((l) => document.body.classList.contains(l)) ||
    (document.documentElement && supportedLangs.includes(document.documentElement.lang)
      ? document.documentElement.lang
      : 'en');
  const grShare = document.querySelector('.gr_share');
  // ===== 2. Characters =====
  const characters = [
    'Melon Soda',
    'Ice Pop',
    'Fruit Punch',
    'Camembert',
    'Brie Cheese',
    'String Cheese',
    'Bacon Roll',
    'Jerky',
    'Black Pudding',
    'DJ Miya'
  ];
  const characterGroupMap = {
    'Melon Soda': 'group1',
    'Ice Pop': 'group1',
    'Fruit Punch': 'group1',

    'Camembert': 'group2',
    'Brie Cheese': 'group2',
    'String Cheese': 'group2',

    'Bacon Roll': 'group3',
    'Jerky': 'group3',
    'Black Pudding': 'group3',

    'DJ Miya': 'group4'
  };
  // ===== 2.1 Result images =====
const resultImages = {
  'Melon Soda': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/melonsoda-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/melonsoda-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/melonsoda-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/melonsoda-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/melonsoda-id.jpg'
  },
  'Ice Pop': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/icepop-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/icepop-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/icepop-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/icepop-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/icepop-id.jpg'
  },
  'Fruit Punch': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/fruitpunch-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/fruitpunch-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/fruitpunch-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/fruitpunch-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/fruitpunch-id.jpg'
  },
  'Camembert': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/camembert-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/camembert-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/camembert-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/camembert-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/camembert-id.jpg'
  },
  'Brie Cheese': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/briecheese-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/briecheese-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/briecheese-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/briecheese-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/briecheese-id.jpg'
  },
  'String Cheese': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/stringcheese-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/stringcheese-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/stringcheese-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/stringcheese-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/stringcheese-id.jpg'
  },
  'Bacon Roll': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/baconroll-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/baconroll-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/baconroll-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/baconroll-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/baconroll-id.jpg'
  },
  'Jerky': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/jerky-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/jerky-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/jerky-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/jerky-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/jerky-id.jpg'
  },
  'Black Pudding': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/blackpudding-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/blackpudding-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/blackpudding-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/blackpudding-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/blackpudding-id.jpg'
  },
  'DJ Miya': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/djmiya-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/djmiya-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/djmiya-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/djmiya-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/result/djmiya-id.jpg'
  }
};
  // ===== 2.2 Share images (Facebook) =====
  // If you have dedicated share assets, map them here; fallback will use result image.
const shareImages = {
  'Melon Soda': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/melonsoda-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/melonsoda-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/melonsoda-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/melonsoda-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/melonsoda-id.jpg'
  },
  'Ice Pop': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/icepop-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/icepop-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/icepop-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/icepop-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/icepop-id.jpg'
  },
  'Fruit Punch': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/fruitpunch-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/fruitpunch-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/fruitpunch-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/fruitpunch-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/fruitpunch-id.jpg'
  },
  'Camembert': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/camembert-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/camembert-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/camembert-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/camembert-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/camembert-id.jpg'
  },
  'Brie Cheese': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/briecheese-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/briecheese-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/briecheese-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/briecheese-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/briecheese-id.jpg'
  },
  'String Cheese': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/stringcheese-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/stringcheese-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/stringcheese-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/stringcheese-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/stringcheese-id.jpg'
  },
  'Bacon Roll': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/baconroll-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/baconroll-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/baconroll-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/baconroll-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/baconroll-id.jpg'
  },
  'Jerky': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/jerky-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/jerky-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/jerky-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/jerky-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/jerky-id.jpg'
  },
  'Black Pudding': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/blackpudding-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/blackpudding-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/blackpudding-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/blackpudding-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/blackpudding-id.jpg'
  },
  'DJ Miya': {
    en: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/djmiya-en.jpg',
    vn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/djmiya-vn.jpg',
    th: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/djmiya-th.jpg',
    cn: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/djmiya-cn.jpg',
    id: 'https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/share/djmiya-id.jpg'
  }
};
  const RESULT_STORAGE_KEY = `ovensmash_pretest_result_v1_${lang}`;

  // ===== 3. Score table (chỉ tính điểm từ câu 3) =====
  // id 1-2: intro/story => không có score mapping
  const questionScores = [
    // Q1
    { id: 3, answers: [
      { 'Melon Soda': 1, 'Bacon Roll': 2, 'DJ Miya': 1 },
      { 'Brie Cheese': 1, 'Jerky': 1 },
      { 'Ice Pop': 1, 'Camembert': 1, 'String Cheese': 1 },
      { 'Fruit Punch': 1, 'Black Pudding': 1 }
    ]},
    // Q2
    { id: 4, answers: [
      { 'Melon Soda': 2, 'DJ Miya': 1 },
      { 'Camembert': 1, 'Brie Cheese': 1 },
      { 'String Cheese': 1, 'Bacon Roll': 1, 'Jerky': 2 },
      { 'Ice Pop': 1, 'Fruit Punch': 1, 'Black Pudding': 1 }
    ]},
    // Q3. A teammate's in danger mid-battle!
    { id: 5, answers: [
      { 'Melon Soda': 1, 'Fruit Punch': 1, 'Bacon Roll': 1, 'Jerky': 1 },
      { 'Ice Pop': 2, 'Black Pudding': 1 },
      { 'Brie Cheese': 1, 'String Cheese': 1 },
      { 'Camembert': 1, 'DJ Miya': 1 }
    ]},
    // Q4. What's your battle style?
    { id: 6, answers: [
      { 'Melon Soda': 1, 'Camembert': 1, 'Bacon Roll': 1 },
      { 'Fruit Punch': 2 },
      { 'String Cheese': 1, 'Jerky': 1 },
      { 'Ice Pop': 1, 'Brie Cheese': 1, 'Black Pudding': 1, 'DJ Miya': 1 }
    ]},
    // Q5. You meet a Cookie who looks super strong
    { id: 7, answers: [
      { 'Melon Soda': 1, 'Jerky': 1 },
      { 'Ice Pop': 1, 'Camembert': 2, 'Black Pudding': 1, 'DJ Miya': 1 },
      { 'Brie Cheese': 1, 'String Cheese': 1 },
      { 'Fruit Punch': 1, 'Bacon Roll': 1 }
    ]},
    // Q6. Where's your dream battleground?
    { id: 8, answers: [
      { 'Fruit Punch': 1, 'Camembert': 1, 'Bacon Roll': 1 },
      { 'Melon Soda': 1, 'DJ Miya': 2 },
      { 'String Cheese': 1, 'String Cheese': 1 },
      { 'Ice Pop': 1, 'Jerky': 1, 'Black Pudding': 1 }
    ]},
    // Q7. Someone underestimates you
    { id: 9, answers: [
      { 'Melon Soda': 1, 'Camembert': 1, 'Bacon Roll': 1 },
      { 'Fruit Punch': 1, 'DJ Miya': 1 },
      { 'Ice Pop': 1, 'String Cheese': 2, 'Black Pudding': 1, 'Black Pudding': 1 },
      { 'Brie Cheese': 2 }
    ]},
    // Q8. What's your dream version of Platter City?
    { id: 10, answers: [
      { 'Melon Soda': 1, 'Bacon Roll': 1, 'DJ Miya': 1 },
      { 'Ice Pop': 1, 'Fruit Punch': 1, 'Jerky': 1 },
      { 'Camembert': 1, 'Brie Cheese': 1, 'String Cheese': 1 },
      { 'Black Pudding': 2 }
    ]}
  ];

  // ===== 4. Question text by language =====
  const questionLang = {
en:[
  {
    id: 1,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-1.jpg",
    title: "Platter City—where countless Cookies gather, each chasing a dream.<br>You have come all this way, carrying a wish you can't let go of.<br><br>",
    answers: ["Continue"]
  },
  {
    id: 2,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-2.jpg",
    title: "The key to making dreams come true?<br>The Oven Crown Cup!<br>Whoever collects the most Oven Crowns <br>gets one wish granted.<br><br>As you gaze up at the neon glow of the city, your heart whispers your wish once more.<br>And suddenly, the sky blazes with light!",
    answers: ["Look up"]
  },
  {
    id: 3,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-3.jpg",
    title: "The Oven Crown drops <br> from the sky—it's game on! <br>What’s your move?",
    answers: [
      "Dive right in—let's gooo!",
      "Size up the competition first.",
      "Quick gear check. Can't fight unprepared.",
      "Get the panicking Cookies out of harm's way."
    ]
  },
  {
    id: 4,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-4.jpg",
    title: "Why do you want <br> Oven Crowns?",
    answers: [
      "To be famous!",
      "To rule with power and glory!",
      ".... Still figuring that out, honestly.",
      "To change the world for the better."
    ]
  },
  {
    id: 5,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-5.jpg",
    title: "A teammate's in danger mid-battle! What do you do?",
    answers: [
      "Dash in and save them!",
      "Stay calm—make a smart plan.",
      "Calculate what I'd gain by helping.",
      "Focus on my own fight."
    ]
  },
  {
    id: 6,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-6.jpg",
    title: "What's your battle style?",
    answers: [
      "Full-on charge! My body moves before my brain.",
      "Teamwork makes the dream work.",
      "Throw 'em off with unpredictable moves!",
      "Read the field, stay cool, and strategize."
    ]
  },
  {
    id: 7,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-7.jpg",
    title: "You meet a Cookie who looks super strong. Your reaction?",
    answers: [
      "Invite them to team up.",
      "Observe carefully—are they stronger than me?",
      "Take them out now before they become a problem.",
      "Oooh, can't wait to fight them! This'll be fun."
    ]
  },
  {
    id: 8,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-8.jpg",
    title: " Where's your dream battleground?",
    answers: [
      "A fiery lava field full of danger and thrill",
      "A roaring stadium packed with fans",
      "A maze of buildings with plenty of places to sneak around",
      "A quiet beach under the moonlight"
    ]
  },
  {
    id: 9,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-9.jpg",
    title: "Someone underestimates you. How do you respond?",
    answers: [
      "Knock 'em flat, right then and there.",
      "Show them what I'm made of in a big, flashy fight!",
      "Ignore it—I don't need their approval.",
      "Use it to set up the perfect counterattack."
    ]
  },
  {
    id: 10,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-10.jpg",
    title: "What's your dream version of Platter City?",
    answers: [
      "A city of cheers, lights, and endless spotlight",
      "A warm, friendly city full of heart",
      "A dazzling city with a hidden dark side",
      "A city where order and justice always stand tall"
    ]
  }
],
id: [
  {
    id: 1,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-1.jpg",
    title: "Platter City, tempat di mana para Cookie berkumpul untuk mengejar mimpinya.<br>Kamu sudah melangkah sejauh ini,<br>membawa sebuah harapan yang tak bisa kamu lepaskan.<br><br>",
    answers: ["Selanjutnya"]
  },
  {
    id: 2,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-2.jpg",
    title: "Kunci buat wujudkan impian?<br>Oven Crown Cup jawabannya!<br>Siapa yang paling banyak dapat Oven Crown,<br>Satu permintaan bakal jadi kenyataan!<br><br>Di balik cahaya neon kota yang berkilauan,<br>Harapan lamamu kembali berbisik pelan.<br><br>Dan tiba-tiba... langit berubah jadi terang!",
    answers: ["Lihat ke Atas"]
  },
  {
    id: 3,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-3.jpg",
    title: "Oven Crown jatuh dari langit—pertarungan dimulai!<br>Apa langkahmu selanjutnya?",
    answers: [
      "Terjun langsung, ayo gas!",
      "Cek ombak dulu, lihat siapa lawannya.",
      "Cek perlengkapan dulu. Jangan bertarung tanpa persiapan",
      "Selamatkan para Cookie yang ketakutan dari bahaya!"
    ]
  },
  {
    id: 4,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-4.jpg",
    title: "Kenapa kamu menginginkan Oven Crown?",
    answers: [
      "Jadilah terkenal!",
      "Berkuasa dengan kekuatan dan kejayaan!",
      "Sejujurnya, masih mencari tahu....",
      "Untuk membuat dunia jadi tempat yang lebih baik."
    ]
  },
  {
    id: 5,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-5.jpg",
    title: "Rekanmu dalam bahaya! Apa yang akan kamu lakukan?",
    answers: [
      "Langsung terjun dan selamatkan mereka!",
      "Tetap tenang—buat rencana yang cerdas.",
      "Hitung dulu apa untungnya kalau aku membantu.",
      "Fokus ke pertarunganku sendiri."
    ]
  },
  {
    id: 6,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-6.jpg",
    title: "Seperti apa gaya bertarungmu?",
    answers: [
      "Serangan penuh! Bergerak secepat kilat",
      "Kerja tim buat mimpi jadi nyata!",
      "Buat lawan bingung dengan gerakan tak terduga!",
      "Baca situasi, tetap tenang, dan atur strategi."
    ]
  },
  {
    id: 7,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-7.jpg",
    title: "Kamu bertemu dengan Cookie yang terlihat sangat kuat.<br>Apa reaksimu?",
    answers: [
      "Ajak mereka gabung timku.",
      "Amati baik-baik—apakah dia lebih kuat dariku?",
      "Kalahkan sekarang sebelum jadi masalah.",
      "Nggak sabar buat hajar mereka! Ini baru namanya seru."
    ]
  },
  {
    id: 8,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-8.jpg",
    title: "Di mana arena pertarungan impianmu?",
    answers: [
      "Medan penuh lava panas yang penuh bahaya dan menegangkan.",
      "Stadion megah penuh sorakan penggemar.",
      "Kota penuh gedung, banyak tempat untuk bersembunyi dan mengintai.",
      "Pantai yang tenang di bawah sinar bulan."
    ]
  },
  {
    id: 9,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-9.jpg",
    title: "Seseorang meremehkanmu.<br>Bagaimana reaksimu?",
    answers: [
      "Kalahkan dia di tempat, saat itu juga.",
      "Tunjukkan kemampuan asliku lewat pertarungan yang seru dan spektakuler!",
      "Abaikan saja, aku tidak butuh pengakuan mereka.",
      "Gunakan kesempatan itu buat serangan balik yang sempurna."
    ]
  },
  {
    id: 10,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-10.jpg",
    title: "Seperti apa versi Platter City impianmu?",
    answers: [
      "Kota penuh sorakan, cahaya, dan spotlight tanpa henti.",
      "Kota yang hangat dan ramah, penuh kebaikan hati.",
      "Kota gemerlap yang menyimpan sisi gelap di balik cahayanya.",
      "Kota tempat ketertiban dan keadilan selalu dijunjung tinggi."
    ]
  }
],
vn: [
  {
    id: 1,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-1.jpg",
    title: "Thành Phố Platter - Nơi các <br> chiến binh Cookie cùng nhau <br>theo đuổi giấc mơ<br><br>Bạn đã đi đến đây - cùng một <br>giấc mơ bạn không thể buông bỏ<br><br>",
    answers: ["Tiếp tục"]
  },
  {
    id: 2,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-2.jpg",
    title: "Đâu là chìa khóa biến điều ước thành hiện thực?<br>Chính là Oven Crown Cup!<br>Chiến binh nào thu thập được nhiều Oven Crowns nhất <br>sẽ được ban cho một điều ước! <br><br>Giữa ánh đèn neon lấp lánh của thành phố, <br> bạn ngẩng đầu nhìn lên bầu trời,<br>và trái tim bạn khẽ thì thầm điều ước ấy… một lần nữa.<br>Và rồi — bầu trời bất chợt bừng sáng rực rỡ!",
    answers: ["Nhìn lên bầu trời"]
  },
  {
    id: 3,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-3.jpg",
    title: "Trận chiến giành lấy <br>Oven Crown đã bắt đầu! <br>Kế hoạch tác chiến của bạn là?",
    answers: [
      "Chiến luôn sợ gì. Xông lên!",
      "Đánh giá đối thủ trước đã.",
      "Kiểm tra trang bị rồi mới chiến đấu nha!",
      "Giúp những chiến hữu Cookie khác thoát khỏi nguy hiểm"
    ]
  },
  {
    id: 4,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-4.jpg",
    title: "Tại sao bạn lại muốn giành lấy <br> Oven Crown?",
    answers: [
      "Vì danh tiếng!",
      "Vì quyền lực và vinh quang!",
      "... Thật ra thì tôi cũng đang đi tìm câu trả lời.",
      "Để thế giới trở nên tốt đẹp hơn."
    ]
  },
  {
    id: 5,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-5.jpg",
    title: "Đồng đội đang lâm nguy! <br> Bạn sẽ làm gì?",
    answers: [
      "Lao đến và cứu đồng đội ngay!",
      "Bình tĩnh, phải lập kế hoạch trước.",
      "Tính toán xem tôi sẽ được lợi gì nếu giúp họ trước đã.",
      "Tập trung vào trận chiến của riêng mình."
    ]
  },
  {
    id: 6,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-6.jpg",
    title: "Phong cách chiến đấu của bạn <br> là gì?",
    answers: [
      "Tay nhanh hơn não - Cứ xông lên trước, suy nghĩ sau!",
      "Phối hợp cùng đồng đội.",
      "Thích đột biến, làm đối thủ bất ngờ!",
      "Quan sát toàn cục, giữ bình tĩnh, chiến đấu có chiến thuật"
    ]
  },
  {
    id: 7,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-7.jpg",
    title: "Bạn gặp một chiến binh Cookie <br> trông có vẻ rất mạnh.<br>Bạn sẽ...",
    answers: [
      "Rủ họ nhập hội",
      "Đánh giá, so sánh xem họ có mạnh hơn mình không",
      "Phải hạ gục họ trước khi họ trở thành mối đe dọa!",
      "Oooh, thật nóng lòng để so tài với họ, sẽ thú vị lắm đây!"
    ]
  },
  {
    id: 8,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-8.jpg",
    title: "Đấu trường trong mơ của bạn <br>là gì?",
    answers: [
      "Một vùng đất dung nham rực lửa đầy nguy hiểm",
      "Một sân vận động sôi động chật kín người hâm mộ",
      "Một mê cung nhà cao tầng với vô số chỗ ẩn nấp",
      "Một bãi biển yên bình dưới ánh trăng"
    ]
  },
  {
    id: 9,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-9.jpg",
    title: "Có ai đó xem thường bạn.<br>Bạn sẽ phản ứng như thế nào?",
    answers: [
      "Hạ gục họ ngay và luôn!",
      "Cho họ thấy sức mạnh thật sự của mình",
      "Phớt lờ đi, tôi chẳng cần sự công nhận của họ.",
      "Đáp trả họ bằng một pha phản đòn chí mạng."
    ]
  },
  {
    id: 10,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-10.jpg",
    title: "Phiên bản Thành Phố <br>Platter trong mơ của bạn <br>sẽ là nơi như thế nào?",
    answers: [
      "Một thành phố sầm uất với ánh hào quang bất tận",
      "Một thành phố ấm áp, thân thiện và đầy ắp tình người",
      "Một thành phố rực rỡ, nhưng cũng đầy những bí ẩn",
      "Một thành phố tôn nghiêm nơi công lý luôn được gìn giữ"
    ]
  }
],
th: [
  {
    id: 1,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-1.jpg",
    title: "คุกกี้มากมายมารวมตัวกันในแพลตเตอร์ซิตี้ เมืองแห่งความฝัน<br>ฉันได้เดินทางไกลมาที่นี่<br>เพื่อทำให้ความปรารถนาอันแรงกล้าเป็นจริง<br><br>",
    answers: ["ต่อไป"]
  },
  {
    id: 2,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-2.jpg",
    title: "กุญแจสู่การทำให้ความปรารถนาเป็นจริงก็คือ…<br>โอเวนคราวน์!<br>ผู้ที่ชนะและคว้าโอเวนคราวน์ได้มากที่สุด<br>จะได้รับโอกาสให้คำอธิษฐานที่ต้องการเพียงหนึ่งเดียวเป็นจริง...<br><br>ฉันมองดูแสงนีออนอันเจิดจ้าของเมือง<br>และนึกถึงความปรารถนาอันแรงกล้าของตัวเองอีกครั้ง<br><br>แต่แล้วในขณะนั้นเอง<br>อยู่ๆ ท้องฟ้าก็เริ่มสว่างไสวขึ้นมา!",
    answers: ["เงยหน้ามองท้องฟ้า"]
  },
  {
    id: 3,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-3.jpg",
    title: "สิ่งที่ปรากฏบนท้องฟ้าคือ... โอเวนคราวน์!<br>การแข่งขันเริ่มขึ้นแล้ว! คุณจะทำอะไรเป็นอย่างแรก?",
    answers: [
      "เข้าร่วมการแข่งขันทันที!",
      "มองดูผู้เข้าแข่งขันรอบๆ ตัว โอกาสที่ฉันจะชนะคือเท่าไรกันนะ?",
      "ต้องตรวจสอบอาวุธและอุปกรณ์ก่อน",
      "อพยพคุกกี้ที่ถูกกวาดไปก่อน!"
    ]
  },
  {
    id: 4,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-4.jpg",
    title: "เหตุผลที่ฉันสะสมโอเวนคราวน์คือ?",
    answers: [
      "ฉันอยากเป็นดาวเด่น!",
      "ฉันต้องการอำนาจและชื่อเสียง!",
      "จริงๆ แล้วยังไม่ได้คิดคำอธิษฐานเลย!",
      "อยากเปลี่ยนโลกให้ดีขึ้น!"
    ]
  },
  {
    id: 5,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-5.jpg",
    title: "เพื่อนร่วมทีมกำลังตกอยู่ในอันตรายระหว่างการต่อสู้!<br>คุณจะทำอย่างไร?",
    answers: [
      "รีบวิ่งไปช่วยทันที",
      "วางแผนกลยุทธ์อย่างใจเย็น",
      "คำนวณผลประโยชน์ที่ได้รับจากการช่วยก่อน",
      "ต้องโฟกัสกับการต่อสู้ตรงหน้าก่อน"
    ]
  },
  {
    id: 6,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-6.jpg",
    title: "สไตล์การต่อสู้ที่ฉันชอบคือ?",
    answers: [
      "โจมตีไปก่อน! ร่างกายต้องเคลื่อนไหวก่อนความคิด!",
      "การต่อสู้แบบร่วมมือกันเป็นทีม!",
      "การต่อสู้ที่เขย่าเวทีด้วยการกระทำที่คาดเดาไม่ได้!",
      "นักยุทธศาสตร์ที่อ่านเกมในสนามรบและวางแผนอย่างเยือกเย็น!"
    ]
  },
  {
    id: 7,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-7.jpg",
    title: "เจอคุกกี้ที่ดูแข็งแกร่งมาก!<br>คุณจะทำยังไงต่อ?",
    answers: [
      "อยากมาร่วมทีมกับเราไหม? แนะนำให้มาร่วมทีมกับเรานะ",
      "แข็งแกร่งกว่าฉันเหรอ? สังเกตคู่ต่อสู้อย่างระมัดระวัง",
      "จะจัดการก่อนใครเลย!",
      "แทบรอไม่ไหวที่จะได้สู้กับคุกกี้ตัวนั้นแล้ว! คงจะสนุกมากเลย!"
    ]
  },
  {
    id: 8,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-8.jpg",
    title: "สถานที่ต่อสู้ที่ฉันชอบคือที่ไหน?",
    answers: [
      "พื้นที่ลาวาอันร้อนแรงที่เต็มไปด้วยอันตรายและความตื่นเต้น",
      "จัตุรัสแพลตเตอร์ที่มีผู้ชมจำนวนมากส่งเสียงเชียร์",
      "พื้นที่อาคารที่ซับซ้อนและมีที่ซ่อนตัวมากมาย",
      "ชายหาดยามค่ำคืนที่มีเสียงคลื่นเบาๆ"
    ]
  },
  {
    id: 9,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-9.jpg",
    title: "เมื่อโดนดูถูก<br>ปฏิกิริยาของฉันคืออะไร?",
    answers: [
      "ล้มคู่ต่อสู้ทันที!",
      "แสดงให้พวกเขาเห็นว่าฉันเป็นคุกกี้แบบไหน! ด้วยการต่อสู้สุดมันส์แบบจัดเต็ม!",
      "ไม่ใส่ใจ สิ่งที่สำคัญไม่ใช่คำวิจารณ์จากผู้อื่นนะ!",
      "วางกลยุทธ์ โดยใช้การดูถูกของอีกฝ่ายเป็นช่องโหว่ แล้วสวนกลับทันที"
    ]
  },
  {
    id: 10,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-10.jpg",
    title: "แพลตเตอร์ซิตี้ในฝันของคุณเป็นเมืองแบบไหน?",
    answers: [
      "เมืองที่เต็มไปด้วยเสียงกู่ร้องและแสงสปอตไลท์",
      "เมืองที่ทำให้รู้สึกอบอุ่นใจ",
      "เมืองที่มีความหรูหราและด้านมืดอยู่ร่วมกัน",
      "เมืองที่รักษาความสงบเรียบร้อยและความยุติธรรม"
    ]
  }
],
cn: [
  {
    id: 1,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-1.jpg",
    title: "許多餅乾懷抱夢想前來的「拼盤市」<br>我從遙遠的地方踏進這座大城市<br>是為了實現一個願望<br><br>",
    answers: ["下一步"]
  },
  {
    id: 2,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-2.jpg",
    title: "實現願望的鑰匙就是...<br>《烤箱皇冠盃》！<br>獲得最多烤箱皇冠的獲勝者<br>可以實現一個願望...<br><br>我看著這座城市絢麗的霓虹燈，<br>並在心裡想著我的願望。<br><br>就在那時候，<br>天空突然出現一道耀眼的光芒！",
    answers: ["抬頭仰望天空"]
  },
  {
    id: 3,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-3.jpg",
    title: "從天而降的是...烤箱皇冠！<br>比賽開始了！我的反應是？",
    answers: [
      "立刻參加比賽！",
      "環顧周圍的參賽者 我的勝算有多大？",
      "先檢查我所擁有的武器和裝備",
      "先疏散被捲進來的餅乾！"
    ]
  },
  {
    id: 4,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-4.jpg",
    title: "我蒐集烤箱皇冠的理由是？",
    answers: [
      "我想成為明星！",
      "我想坐擁權力和名聲！",
      "其實，我還沒想好心願！",
      "我想讓世界變得更美好！"
    ]
  },
  {
    id: 5,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-5.jpg",
    title: "隊員在戰鬥中遇到危險了！<br>我會怎麼做？",
    answers: [
      "立刻跑去救援",
      "冷靜制定策略",
      "評估拯救隊員的利弊",
      "首先專注於眼前的戰鬥"
    ]
  },
  {
    id: 6,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-6.jpg",
    title: "我喜歡的戰鬥風格是？",
    answers: [
      "先衝再說！直覺行動派！",
      "團隊合作的戰鬥！",
      "透過無法預測的行動來動搖局勢的戰鬥！",
      "觀察戰場上的情勢 冷靜制定企劃的軍師！"
    ]
  },
  {
    id: 7,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-7.jpg",
    title: "我遇見一個看起來很強的餅乾！<br>我會怎麼選擇？",
    answers: [
      "攜手合作吧！提議加入隊伍",
      "他會不會比我強？ 仔細觀察對手",
      "他看起來有望成為冠軍！先打倒他再說！",
      "好想快點和那個餅乾打一場！一定很好玩！"
    ]
  },
  {
    id: 8,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-8.jpg",
    title: "我喜歡的戰鬥地點是？",
    answers: [
      "刺激危險的熾熱熔岩地形",
      "滿是觀眾的拼盤廣場",
      "有許多藏身之處的複雜建築區域",
      "傳來陣陣海浪聲的夜晚沙灘"
    ]
  },
  {
    id: 9,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-9.jpg",
    title: "當有人小看你時，<br>你會有什麼反應？",
    answers: [
      "立刻擊倒對手！",
      "讓你知道我是什麼樣的餅乾！參加萬眾矚目的戰鬥",
      "不在意！別人怎麼想不重要！",
      "利用對手小看我這點，制定反擊策略"
    ]
  },
  {
    id: 10,
    bg: "https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-10.jpg",
    title: "你所夢想的拼盤市是座什麼樣的城市呢？",
    answers: [
      "充滿歡呼與鎂光燈焦點的城市",
      "充滿溫暖情懷的城市",
      "華麗與黑暗並存的城市",
      "守秩序的正義城市"
    ]
  }
],
  };

  // ===== 5. Merge text + scores =====
  const questions = questionLang[lang].map(q => {
    const scoreData = questionScores.find(s => s.id === q.id);
    return {
      id: q.id,
      bg: q.bg,
      title: q.title,
      answers: q.answers.map((text, i) => ({
        text,
        scores: (scoreData && scoreData.answers && scoreData.answers[i]) ? scoreData.answers[i] : {}
      }))
    };
  });

  // ===== 6. Init scores =====
  const scores = {};
  characters.forEach(c => {
    scores[c] = 0;
  });

  // ===== 7. Game state =====
  let currentQuestion = 0;
  /** @type {number[]} selected answer index per question (0-based) */
  let selectedAnswers = [];
  let isShowingResult = false;
  /** @type {string} */
  let currentResultCharacter = '';

  // ===== 8. Append HTML (render from JS) =====
  const root = document.querySelector('#popup_game_root') || document.body;
  const btnBack = root.querySelector('.btn_back');
  const progressInner = document.querySelector('.bar-progress-inner');
  const progressIcon = document.querySelector('.bar-progress .icon_progress');
  const popupGameSection = document.querySelector('#popup_game');
  const popupResultSection = document.querySelector('#popup_result');
  const popupConfirmSection = document.querySelector('#popup_confirm');
  const resultImgEl = document.querySelector('#popup_game_result .img_result img');
  const btnDownload = document.querySelector('#popup_game_result .btn_download');
  const btnRetake = document.querySelector('#popup_game_result .btn_retake');
  const btnShare = document.querySelector('#popup_game_result .btn_share');
  const btnCloseGame = document.querySelector('#popup_game .btn-close');
  const btnConfirmLeave = document.querySelector('#popup_confirm .btn__confirm');
  root.insertAdjacentHTML('beforeend', `
    <div class="content_game">
      <div class="bg-question">
        <img src="https://cdn-mainsite-aka.vnggames.com/products/ovensmash/landing/2026-pre-reg/dist/assets/libraryMainsite-t-popup/images/question/background/bg-ques-1.jpg" alt="">
      </div>
      <div class="each_question">
        <label class="question-title"></label>
        <div class="gr_answer"></div>
      </div>
    </div>
  `);

  const container = root.querySelector('.content_game');
  if (!container) return;

  // ===== 9. DOM (let để gán lại khi Back từ màn result) =====
  let titleEl = container.querySelector('.question-title');
  let bgImg = container.querySelector('.bg-question img');
  let answersEl = container.querySelector('.gr_answer');

  if (!titleEl || !bgImg || !answersEl) return;
  // ===== 9. Apply group class =====
  function applyGroupClass(character) {
    if (!grShare) return;
  
    // remove class cũ
    grShare.classList.remove('group1', 'group2', 'group3', 'group4');
  
    // add class mới
    const group = characterGroupMap[character];
    if (group) {
      grShare.classList.add(group);
    }
  }
  // ===== 10. Show/hide Back button (from question 2 to end, and on result) =====
  function updateBackButton() {
    if (!btnBack) return;
    const show = currentQuestion >= 1 || isShowingResult;
    btnBack.style.display = show ? '' : 'none';
  }

  // ===== 11. Progress bar items (add/remove when next/back) =====
  function updateProgressBar() {
    if (!progressInner) return;
    const count = isShowingResult ? questions.length : Math.min(currentQuestion + 1, questions.length);

    while (progressInner.children.length < count) {
      const idx = progressInner.children.length + 1;
      const el = document.createElement('div');
      el.className = `progress-item progress-item-${idx}`;
      progressInner.appendChild(el);
    }
    while (progressInner.children.length > count) {
      progressInner.removeChild(progressInner.lastElementChild);
    }

    if (progressIcon) {
      // Each segment is 22px wide in SCSS
      progressIcon.style.left = `${count * 22}px`;
    }
  }

  function showPopup(el) {
    if (!el) return;
    el.classList.add('active');
  }

  function hidePopup(el) {
    if (!el) return;
    el.classList.remove('active');
  }

  function scrollPopupToTop(popupEl) {
    if (!popupEl) return;
    const content = popupEl.querySelector('.MS__content');
    if (content) {
      try {
        content.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (_) {
        content.scrollTop = 0;
      }
    }
  }

  function isInProgress() {
    return !isShowingResult && currentQuestion >= 0 && currentQuestion < questions.length;
  }

  function getResultImage(character) {
    const map = resultImages[character] || {};
    return map[lang] || map.en || '';
  }

  function getShareImage(character) {
    const map = shareImages[character] || {};
    return map[lang] || map.en || getResultImage(character) || '';
  }

  function toAbsoluteUrl(maybeRelativeUrl) {
    if (!maybeRelativeUrl) return '';
    try {
      return new URL(maybeRelativeUrl, window.location.origin + window.location.pathname).toString();
    } catch (_) {
      return maybeRelativeUrl;
    }
  }

  function saveResultToStorage(character) {
    const payload = {
      character,
      imgSrc: getResultImage(character),
      shareImgSrc: getShareImage(character),
      savedAt: Date.now()
    };
    try {
      localStorage.setItem(RESULT_STORAGE_KEY, JSON.stringify(payload));
    } catch (_) {
      // ignore storage errors (private mode/quota/etc.)
    }
  }

  function readSavedResult() {
    try {
      const raw = localStorage.getItem(RESULT_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  }

  // ===== 12. Load question =====
  function loadQuestion() {
    isShowingResult = false;
    const q = questions[currentQuestion];
    const isIntro = q.id === 1 || q.id === 2;
    container.classList.toggle('is-intro-question', isIntro);

    titleEl.innerHTML = q.title;
    bgImg.src = q.bg;
    answersEl.innerHTML = '';

    q.answers.forEach((ans, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
    
      // 👉 ADD LOGIC HERE
      let extraClass = '';
      if (q.id === 1) {
        extraClass = ' answer-item--intro1';
      } else if (q.id === 2) {
        extraClass = ' answer-item--intro2';
      } 
      // else if (isIntro) {
      //   extraClass = ' answer-item--intro';
      // }
    
      btn.className = 'answer-item' + extraClass;
    
      const span = document.createElement('span');
      span.textContent = ans.text;
      btn.appendChild(span);
      btn.dataset.answerIndex = String(i);
      answersEl.appendChild(btn);
    });
    updateProgressBar();
    updateBackButton();
  }

  // ===== 13. Subtract score for one answer (for Back) =====
  function subtractAnswerScore(questionIndex, answerIndex) {
    const answer = questions[questionIndex].answers[answerIndex];
    if (answer && answer.scores) {
      for (let char in answer.scores) {
        scores[char] -= answer.scores[char];
      }
    }
  }

  // ===== 14. Go back to previous question =====
  function goBack() {
    if (isShowingResult) {
      const lastIdx = questions.length - 1;
      const lastSelected = selectedAnswers[lastIdx];
      if (lastSelected !== undefined) subtractAnswerScore(lastIdx, lastSelected);
      selectedAnswers[lastIdx] = undefined;
      currentQuestion = lastIdx;
      container.innerHTML = `
        <div class="bg-question">
          <img src="" alt="">
        </div>
        <div class="each_question">
          <label class="question-title"></label>
          <div class="gr_answer"></div>
        </div>
      `;
      const _titleEl = container.querySelector('.question-title');
      const _bgImg = container.querySelector('.bg-question img');
      const _answersEl = container.querySelector('.gr_answer');
      if (_titleEl && _bgImg && _answersEl) {
        titleEl = _titleEl;
        bgImg = _bgImg;
        answersEl = _answersEl;
        attachAnswerClick();
        loadQuestion();
      }
      return;
    }
    if (currentQuestion <= 0) return;
    const prevSelected = selectedAnswers[currentQuestion];
    if (prevSelected !== undefined) subtractAnswerScore(currentQuestion, prevSelected);
    selectedAnswers[currentQuestion] = undefined;
    currentQuestion--;
    loadQuestion();
  }

  function attachAnswerClick() {
    answersEl.addEventListener('click', onAnswerClick);
  }

  function onAnswerClick(e) {
    const el = e.target;
    if (!(el instanceof HTMLElement)) return;

    const btn = el.closest('.answer-item');
    if (!(btn instanceof HTMLButtonElement)) return;

    const idxStr = btn.dataset.answerIndex;
    const index = idxStr ? Number(idxStr) : NaN;
    if (!Number.isFinite(index)) return;

    answersEl.querySelectorAll('.answer-item').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');

    selectedAnswers[currentQuestion] = index;
    const answer = questions[currentQuestion].answers[index];
    if (answer && answer.scores) {
      for (let char in answer.scores) {
        scores[char] += answer.scores[char];
      }
    }

    currentQuestion++;
    setTimeout(function () {
      if (currentQuestion < questions.length) {
        loadQuestion();
      } else {
        showResult();
      }
    }, 300);
  }

  // ===== 15. Click answer (event delegation) =====
  answersEl.addEventListener('click', onAnswerClick);

  // ===== 16. Show result =====
  function showResult() {
    isShowingResult = true;
    updateProgressBar();
    if (btnBack) btnBack.style.display = 'none';
    let maxScore = -1;
    let resultCharacter = '';

    for (let char in scores) {
      if (scores[char] > maxScore) {
        maxScore = scores[char];
        resultCharacter = char;
      }
    }
    currentResultCharacter = resultCharacter;
    applyGroupClass(resultCharacter);

    if (resultImgEl) {
      resultImgEl.src = getResultImage(resultCharacter);
    }
    saveResultToStorage(resultCharacter);
    hidePopup(popupGameSection);
    showPopup(popupResultSection);
    scrollPopupToTop(popupResultSection);
  }

  // ===== 17. Back button click =====
  if (btnBack) {
    btnBack.addEventListener('click', goBack);
    btnBack.style.display = 'none';
  }

  // ===== 17.1 Result actions (download / retake) =====
  if (btnDownload) {
    btnDownload.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!resultImgEl || !resultImgEl.src) return;
      const url = resultImgEl.src;
      const name = url.split('/').pop()?.split('?')[0] || 'result.jpg';
      const triggerDownload = (href) => {
        const a = document.createElement('a');
        a.href = href;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        a.remove();
      };

      try {
        const response = await fetch(url, { mode: 'cors' });
        if (!response.ok) throw new Error(`Download failed: ${response.status}`);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        triggerDownload(objectUrl);
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1500);
      } catch (error) {
        // Fallback when remote server blocks CORS/download.
        triggerDownload(url);
      }
    });
  }

  if (btnRetake) {
    btnRetake.addEventListener('click', (e) => {
      e.preventDefault();
      // reset scores
      characters.forEach((c) => { scores[c] = 0; });
      selectedAnswers = [];
      currentQuestion = 0;
      isShowingResult = false;
      showPopup(popupGameSection);
      hidePopup(popupResultSection);
      loadQuestion();
    });
  }
// if (btnShare) {
//   btnShare.addEventListener('click', (e) => {
//     e.preventDefault();

//     const saved = readSavedResult();
//     const character = saved?.character || currentResultCharacter;
//     const img = getShareImage(character);
//     const shareUrl = toAbsoluteUrl(img);

//     if (!shareUrl) return;

//     const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;

//     // ✅ iOS-friendly
//     const a = document.createElement('a');
//     a.href = fbUrl;
//     a.target = '_blank';
//     a.rel = 'noopener noreferrer';

//     document.body.appendChild(a); // cần cho iOS
//     a.click();
//     document.body.removeChild(a);
//   });
// }

// if (btnShare) {
//   btnShare.addEventListener('click', (e) => {
//     e.preventDefault();
//     const saved = readSavedResult();
//     const character = saved?.character || currentResultCharacter;
//     const img = getShareImage(character);
//     const name = img.split('/').pop().replace(/\.[^/.]+$/, '');
//     // ❗ KHÔNG dùng image nữa
//  const baseUrl = 'https://ovensmash.vnggames.com/pre-register';

// const shareUrl = `${baseUrl}?sharelang=${lang}&shareimg=${name}`;
//     console.log(shareUrl);
//     const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;


//    // ✅ iOS-friendly
//     const a = document.createElement('a');
//     a.href = fbUrl;
//     a.target = '_blank';
//     a.rel = 'noopener noreferrer';

//     document.body.appendChild(a); // cần cho iOS
//     a.click();
//     document.body.removeChild(a);
//   });
// }
if (btnShare) {
  btnShare.addEventListener('click', (e) => {
    e.preventDefault();

    const saved = readSavedResult();
    const character = saved?.character || currentResultCharacter;
    const img = getShareImage(character);
    const name = img.split('/').pop().replace(/\.[^/.]+$/, '');

    const baseUrl = 'https://ovensmash.vnggames.com/pre-register';
    const shareUrl = `${baseUrl}?sharelang=${lang}&shareimg=${name}&v=${Date.now()}`;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      // 👉 thử mở app FB
      window.location.href = `fb://share/?link=${encodeURIComponent(shareUrl)}`;

      // 👉 fallback nếu fail
      // setTimeout(() => {
      //   window.open(
      //     `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      //     '_blank'
      //   );
      // }, 500);

    } else {
      // 👉 PC
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
        '_blank'
      );
    }
  });
}

  // ===== 17.2 Close game => confirm leave when in progress =====
  if (btnCloseGame) {
    btnCloseGame.addEventListener('click', (e) => {
      if (!popupGameSection || !popupGameSection.classList.contains('active')) return;
      if (isShowingResult) return;

      e.preventDefault();
      e.stopPropagation();
      showPopup(popupConfirmSection);
    }, true);
  }

  if (btnConfirmLeave) {
    btnConfirmLeave.addEventListener('click', (e) => {
      e.preventDefault();
      hidePopup(popupConfirmSection);
      hidePopup(popupGameSection);
    });
  }
  const saved = readSavedResult();
  if (saved?.character) {
    applyGroupClass(saved.character);
  }
  // ===== 18. Start game =====
  loadQuestion();
});

window.addEventListener('message', (event) => {
  if (event.data?.type === 'libraryMainsite-t-article:ok') {
  $('#popup_rule').removeClass('active');
  }
});